const { VUE_APP_MICRO_ENTRY } = process.env
import router from '../router'
import actions from './actions';
const apps = [
	/**
	* name: 微应用名称 - 具有唯一性
	* entry: 微应用入口 - 通过该地址加载微应用
	* container: 微应用挂载节点 - 微应用加载完成后将挂载在该节点上
	* activeRule: 微应用触发的路由规则 - 触发路由规则后将加载该微应用
	*/

	{
		name: "marking-micro-service",
		entry: VUE_APP_MICRO_ENTRY + '/markingservice/',
		container: "#service-container",
		activeRule: ["/marking-service/:catchAll(.*)", "/marking-service/details"],
		props: {
			MicroBaseRouter: router, // 将主应用router实例传递给子应用
			actions: actions
		}
	},
];
export default apps;